import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { appConfig } from 'src/constants/appConfig';
import routes from 'src/constants/routes';
import tauronLogo from 'src/assets/tauron/logo.jpg';
import tauronLogoHorizontal from 'src/assets/tauron/logo-horizontal.png';
import { ReactComponent as HelpIcon } from 'src/assets/tauron/help.svg';
import TauronWidthContainer from 'src/components/tauronWidthContainer';

import { StyledAppBar, StyledContent, StyleHelpBtn } from './styles';

const AppBarTauron = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const isSquareLogo = useMediaQuery(theme.breakpoints.up(970));

  const handleOpenSupportTab = () => {
    navigate(routes.help);
  };

  return (
    <StyledAppBar>
      <TauronWidthContainer>
        <StyledContent>
          <a href={appConfig.brandURL || '/'}>
            {isSquareLogo ? (
              <img src={tauronLogo} width={100} height={100} alt="brandLogo" />
            ) : (
              <img src={tauronLogoHorizontal} height={50} alt="brandLogo" />
            )}
          </a>
          <StyleHelpBtn
            variant="text"
            color="secondary"
            size="small"
            onClick={handleOpenSupportTab}
          >
            <HelpIcon />
            {'\u00A0\u00A0\u00A0'}
            <Typography
              sx={{ marginTop: isSquareLogo ? '4px' : '0px' }}
              variant="buttonMedium"
              fontWeight="200"
              fontSize="17px"
            >
              {t('HOME_HELP')}
            </Typography>
          </StyleHelpBtn>
        </StyledContent>
      </TauronWidthContainer>
    </StyledAppBar>
  );
};

export default AppBarTauron;
